module.exports = __webpack_public_path__ + "a331b8f5224e4ab53170261ee795bfff.png";